import { render, staticRenderFns } from "./inputtext.vue?vue&type=template&id=ab991cda&"
import script from "./inputtext.vue?vue&type=script&lang=js&"
export * from "./inputtext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports